export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8156.bc4b97d2.jpg";